import React from "react";
import { cn } from "src/common/utils";

interface WizardStepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  onStepClick?: (step: number) => void;
}

export function WizardStepIndicator({
  currentStep,
  totalSteps,
  onStepClick,
}: WizardStepIndicatorProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-xs text-muted-foreground">
        Step {currentStep} of {totalSteps}
      </span>
      <div className="flex items-center gap-1.5">
        {steps.map((step) => {
          const isCompleted = step < currentStep;
          const isCurrent = step === currentStep;
          const isClickable = onStepClick && step < currentStep;

          return (
            <button
              key={step}
              type="button"
              onClick={() => isClickable && onStepClick(step)}
              disabled={!isClickable}
              className={cn(
                "w-2 h-2 rounded-full transition-all",
                (isCompleted || isCurrent) && "bg-primary",
                !isCompleted && !isCurrent && "bg-muted",
                isClickable && "cursor-pointer hover:bg-primary/80"
              )}
              aria-label={`Step ${step}`}
            />
          );
        })}
      </div>
    </div>
  );
}
